import { IBranding } from '@/src/types/meetData.type'

export const initialBranding: IBranding = {
  primary_color: '#3396fa',
  text_primary_color: '#ffffff',
  border_radius: 8,

  logo: '',
  img_background_speaker: '',

  url_log_out: '',

  title_soc: null,
  description_soc: null,

  img_soc: '',
  favicon: '',

  video_waiting: '',
  title_waiting: null,
  description_waiting: null,
  img_waiting: '',
}
